const ipv4 = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;

export default ipv4;


// WEBPACK FOOTER //
// ./src/common/reg/ipv4.js